const ru = {
  contributorsTxt: 'участники',
  activeHeroes: 'Активные участники',
  heroes: 'Герои',
  socialLinkTxt: 'Ссылка',
};

export default ru;
